/*
 * Paginare pe variatii pentru sectiunea variant-collection-product-grid.
 * Toate variatiile disponibile sunt randate in pagina (maxim 250 de produse),
 * iar acest script afiseaza doar felia paginii curente, citita din ?pagina=N.
 */
(function () {
  const PARAM = 'pagina';
  const HIDDEN_CLASS = 'is-variant-hidden';

  const state = { container: null, items: [], perPage: 12, totalPages: 1, page: 1, shown: 0, observer: null };

  function getPageFromUrl() {
    const page = parseInt(new URLSearchParams(window.location.search).get(PARAM), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function buildUrl(page) {
    const params = new URLSearchParams(window.location.search);
    if (page > 1) params.set(PARAM, page);
    else params.delete(PARAM);
    const search = params.toString();
    return window.location.pathname + (search ? '?' + search : '');
  }

  // Afiseaza variatiile cu index in intervalul [from, to] (1-based).
  function showRange(from, to) {
    state.items.forEach((item) => {
      const index = Number(item.dataset.variantIndex);
      item.classList.toggle(HIDDEN_CLASS, index < from || index > to);
    });
    if (typeof RefurbishedEvents !== 'undefined') RefurbishedEvents.emit('ON_PRODUCT_LIST_UPDATED');
  }

  function pageLink(page, label, extraClass) {
    const span = document.createElement('span');
    span.className = extraClass;
    const link = document.createElement('a');
    link.href = buildUrl(page);
    link.dataset.page = page;
    link.innerHTML = label;
    span.appendChild(link);
    return span;
  }

  function textSpan(text, className) {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    return span;
  }

  // Aceeasi structura ca default_pagination din Shopify, ca sa pastram stilurile temei.
  function renderPagination(nav) {
    const { page, totalPages } = state;
    nav.innerHTML = '';
    if (page > 1) nav.appendChild(pageLink(page - 1, '&laquo;', 'prev'));

    const windowSize = 1;
    let lastRendered = 0;
    for (let i = 1; i <= totalPages; i++) {
      const isEdge = i === 1 || i === totalPages;
      const isNear = Math.abs(i - page) <= windowSize;
      if (!isEdge && !isNear) continue;
      if (lastRendered && i - lastRendered > 1) nav.appendChild(textSpan('…', 'deco'));
      nav.appendChild(i === page ? textSpan(String(i), 'page current') : pageLink(i, String(i), 'page'));
      lastRendered = i;
    }

    if (page < totalPages) nav.appendChild(pageLink(page + 1, '&raquo;', 'next'));
  }

  function goToPage(page, nav) {
    state.page = Math.min(Math.max(page, 1), state.totalPages);
    const from = (state.page - 1) * state.perPage + 1;
    showRange(from, from + state.perPage - 1);
    renderPagination(nav);
    // replaceState (nu pushState): filtrele asculta popstate si ar reseta rezultatele.
    history.replaceState(history.state, '', buildUrl(state.page));
  }

  function initNumbered(nav) {
    nav.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-page]');
      if (!link) return;
      event.preventDefault();
      goToPage(Number(link.dataset.page), nav);
      const grid = document.getElementById('CollectionProductGrid');
      if (grid) window.scrollTo({ top: grid.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
    });
    goToPage(getPageFromUrl(), nav);
  }

  function initLoadMore(wrapper, button, infinite) {
    // La "load more" afisam cumulativ paginile 1..N.
    const loadMore = () => {
      if (state.page >= state.totalPages) return;
      state.page += 1;
      showRange(1, state.page * state.perPage);
      history.replaceState(history.state, '', buildUrl(state.page));
      if (state.page >= state.totalPages) {
        if (state.observer) state.observer.disconnect();
        wrapper.remove();
      }
    };

    state.page = Math.min(getPageFromUrl(), state.totalPages);
    showRange(1, state.page * state.perPage);
    if (state.page >= state.totalPages) {
      wrapper.remove();
      return;
    }

    button.addEventListener('click', loadMore);
    if (infinite) {
      state.observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => entry.intersectionRatio === 1 && loadMore()),
        { threshold: 1 }
      );
      state.observer.observe(button);
    }
  }

  function init() {
    if (state.observer) state.observer.disconnect();
    state.observer = null;

    const container = document.querySelector('[data-variant-container]');
    if (!container) return;

    state.container = container;
    state.items = Array.from(container.querySelectorAll('[data-variant-index]'));
    state.perPage = Number(container.dataset.perPage) || 12;
    state.totalPages = Math.max(1, Math.ceil(state.items.length / state.perPage));
    state.page = 1;

    const wrapper = document.querySelector('[data-variant-pagination-wrapper]');
    if (!wrapper) return;

    const nav = wrapper.querySelector('[data-variant-pagination]');
    const button = wrapper.querySelector('[data-variant-load-more]');
    if (nav) initNumbered(nav);
    else if (button) initLoadMore(wrapper, button, wrapper.dataset.paginationType === 'infinite');
  }

  window.VariantPagination = { init };
})();
